module.exports = __webpack_public_path__ + "static/media/major-family.88a9a745.svg";